// extracted by mini-css-extract-plugin
module.exports = {"header":"CustomHero-module--header--MCh6F","thumbnail":"CustomHero-module--thumbnail--1P76x","over":"CustomHero-module--over--2zz3j"};